import React from "react";
import { Link } from "react-router-dom"; // optional - swap with <a> if not using react-router
import "../assets/css/footer.css";

// Replace these with your actual gallery images
import g1 from "../assets/images/slide/1.jpeg";
import g2 from "../assets/images/slide/2.jpeg";
import g3 from "../assets/images/slide/6.jpeg";
import g4 from "../assets/images/slide/12.jpeg";
import g5 from "../assets/images/slide/16.jpg";
import g6 from "../assets/images/slide/22.jpg";

const Footer = () => {
  return (
    <footer className="luth-footer" role="contentinfo">
      {/* thin top stripe (small height) */}
      <div className="footer-top">
        <div className="container">
          <div className="top-row">
            <div className="top-left">
              <small>Admissions & announcements • Stay updated</small>
            </div>
            <div className="top-right">
              <small>Contact: schoolsadmin@luth.gov.ng</small>
            </div>
          </div>
        </div>
      </div>

      {/* main area (two large columns: left = Explore+Gallery, right = About card) */}
      <div className="footer-main">
        <div className="container footer-grid">
          {/* LEFT: grouped area containing LINKS and GALLERY */}
          <div className="left-combo">
            {/* Links column */}
            <div className="footer-col links-col">
              <h4>Explore</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/schools">Schools</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
                <li>
                  <Link to="/admissions">Admissions</Link>
                </li>
              </ul>
            </div>

            {/* Gallery column */}
            <div className="footer-col gallery-col">
              <h4>Gallery</h4>
              <div className="gallery-grid" aria-hidden="false">
                {[g1, g2, g3, g4, g5, g6].map((src, i) => (
                  <div className="gallery-item" key={i}>
                    <img src={src} alt={`Gallery ${i + 1}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT: About card (different shade) */}
          <div className="footer-col about-col">
            <div className="about-card">
              <h4>About LUTH Schools</h4>
              <p>
                Lagos University Teaching Hospital Schools deliver practical,
                community-focused health education across multiple disciplines.
                We prepare graduates for local service and global opportunities.
              </p>

              <div className="about-quicklinks">
                <Link to="/vision" className="pill">
                  Vision & Mission
                </Link>
                <Link to="/programmes" className="pill">
                  Programmes
                </Link>
                <Link to="/admissions" className="pill">
                  How to Apply
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* bottom small row: copyright left, socials right */}
      <div className="footer-bottom">
        <div className="container footer-bottom-row">
          <div className="copyright">
            © Copyright 2026
            <br />
            Lagos University Teaching Hospital Schools
          </div>

          <div className="socials" aria-label="Follow LUTH Schools">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="social-btn"
            >
              {" "}
              {/* svg */}
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2.2v-2.9h2.2V9.3c0-2.2 1.3-3.4 3.2-3.4.9 0 1.8.2 1.8.2v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.3l-.4 2.9h-1.9v7A10 10 0 0 0 22 12z" />
              </svg>
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="social-btn"
            >
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M22 5.8c-.6.3-1.2.5-1.9.6.7-.4 1.2-1 1.4-1.8-.6.4-1.3.7-2.1.8C18.5 4.6 17.6 4 16.6 4c-1.7 0-3 1.5-2.6 3.1-2.2-.1-4.1-1.2-5.4-2.8-.9 1.6-.1 3.7 1.5 4.7-.5 0-1.1-.1-1.6-.4 0 1.9 1.4 3.6 3.2 4-.5.1-1 .2-1.6.1.5 1.6 2 2.8 3.7 2.8-1.6 1.2-3.6 1.9-5.6 1.9-.4 0-.8 0-1.2-.1 2 1.3 4.3 2 6.9 2 8.3 0 12.8-6.9 12.8-12.8v-.6c.9-.7 1.6-1.4 2.2-2.2-.8.4-1.7.7-2.6.8z" />
              </svg>
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="social-btn"
            >
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm5.5-.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
              </svg>
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="social-btn"
            >
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M4.98 3.5C3.88 3.5 3 4.4 3 5.5c0 1.1.88 2 1.98 2s1.98-.9 1.98-2C6.96 4.4 6.08 3.5 4.98 3.5zM3.5 21h3v-9h-3v9zM9.5 12h2.9v1.2h.04c.41-.7 1.42-1.4 2.92-1.4 3.12 0 3.7 2 3.7 4.6V21h-3v-4.5c0-1.1 0-2.4-1.5-2.4-1.5 0-1.7 1.1-1.7 2.3V21h-3v-9z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
